import React from 'react';
import { useForm } from 'react-hook-form';
import { Form, Button } from 'react-bootstrap';

const ContactForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    alert('Thank you for your message! We will contact you soon.');
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="p-4 bg-white rounded shadow-sm">
      <h3 className="mb-4">Get in Touch</h3>
      
      <Form.Group className="mb-3">
        <Form.Label>Full Name</Form.Label>
        <Form.Control
          type="text"
          {...register("name", { required: "Name is required" })}
          className={errors.name ? 'is-invalid' : ''}
        />
        {errors.name && (
          <Form.Text className="text-danger">{errors.name.message}</Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Email Address</Form.Label>
        <Form.Control
          type="email"
          {...register("email", { 
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address"
            }
          })}
          className={errors.email ? 'is-invalid' : ''}
        />
        {errors.email && (
          <Form.Text className="text-danger">{errors.email.message}</Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control
          type="tel"
          {...register("phone", { 
            pattern: {
              value: /^[+]?[\d\s-]+$/,
              message: "Invalid phone number"
            }
          })}
          className={errors.phone ? 'is-invalid' : ''}
        />
        {errors.phone && (
          <Form.Text className="text-danger">{errors.phone.message}</Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label>Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          {...register("message", { 
            required: "Message is required",
            minLength: {
              value: 10,
              message: "Message must be at least 10 characters"
            }
          })}
          className={errors.message ? 'is-invalid' : ''}
        />
        {errors.message && (
          <Form.Text className="text-danger">{errors.message.message}</Form.Text>
        )}
      </Form.Group>

      <Button type="submit" className="btn-gold-filled w-100">
        Send Message
      </Button>
    </Form>
  );
};

export default ContactForm;